module.exports = __webpack_public_path__ + "static/cinzel-variablefont_wght-webfont-4f92a1970b0565bad4e8948e209438e7.woff";